import Api_Usermanagement from '../api-usermanagement'

const api = new Api_Usermanagement().init()

const getSIPAll = (credential, filter, cus) => {
  return api.get(
    `/sip_order?credentials=${credential}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}
const createSIP = (cred, data) => {
  return api.post(`/sip_order/store?credentials=${cred}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSIPDetail = (id, credential, isrevision = 'false') => {
  return api.get(`/sip_order/detail/${id}?credentials=${credential}&isRevision=${isrevision}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rejectSIP = (id, notes, lang) => {
  return api.post(
    `/sip_order/reject/${id}?credentials=${localStorage.getItem('credential')}`,
    {reject_note: notes, lang: lang},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const revisionSIP = (id, notes, lang) => {
  return api.post(
    `/sip_order/revision/${id}?credentials=${localStorage.getItem('credential')}`,
    {revision_note: notes, lang: lang},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const approveSIP = (id, credential, data = {}) => {
  return api.post(`/sip_order/approve/${id}?credentials=${credential}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPOApproved = (credential) => {
  return api.get(`/sip_order/po-number-approved?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPOApprovedSearch = (id, name, sektor) => {
  return api.get(
    `/sip_order/po-number-approved?credentials=${localStorage.getItem(
      'credential'
    )}&po_number=${id}&customer_name=${name}&sector_id=${sektor}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPOforSIP = (id, credential) => {
  return api.get(`/sip_order/po-approved-detail/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRegardingSIP = () => {
  return api.get(`/sip_order/type-list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSIPApproval = (credential, filter, cus, checked = '') => {
  return api.get(
    `/sip_order/get-otorisator${checked}?credentials=${credential}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getSIPApprovalSearch = (
  credential,
  sip,
  po,
  date,
  date2,
  anper,
  cust,
  regarding,
  quantum,
  price,
  est_date,
  status,
  checked = ''
) => {
  return api.get(
    `/sip_order/get-otorisator${checked}?credentials=${credential}&SIP_number=${sip}&po_number=${po}&from_date=${date}&to_date=${date2}&sales_org_code=${anper}&customer_name=${cust}&perihal=${regarding}&total_quantum=${quantum}&price=${price}&estimate_date=${est_date}&status=${status}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAccesses = (id, sub) => {
  return api.get(`/role-access/detail/${id}/${sub || 133}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSIPSearch = (
  credential,
  po,
  date,
  date2,
  anper,
  cust,
  regarding,
  quantum,
  est_date,
  status,
  sector,
  ptype,
  sip
) => {
  return api.get(
    `/sip_order?credentials=${credential}&po_number=${po}&from_date=${date}&to_date=${date2}&sales_org_code=${anper}&customer_name=${cust}&perihal=${regarding}&total_quantum=${quantum}&estimate_date=${est_date}&status=${status}&sector_id=${sector}&product_type=${ptype}&SIP_number=${sip}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const unduhSIP = (id, lang) => {
  return api.get(`/sip_order/print/sip/${id}?lang=${lang}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rollbackSIP = (id, credential, lang) => {
  return api.put(`/sip_order/rollback/${id}?credentials=${credential}&lang=${lang}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const updateAmendment = (id, data) => {
  return api.put(
    `/sip_order/update-amendment/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const resubmitSIP = (id, data) => {
  return api.put(
    `/sip_order/resubmit/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getCommentSIP = (id) => {
  return api.get(`/comment/${id}/sip_notes?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const signingDocument = (id, data) => {
  return api.post(`/sip_order/signing/signing-document/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const generateOTP = (id) => {
  return api.post(`/sip_order/signing/generate-otp-signatur/${id}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getOtorisator = (data) => {
  let params = data.map((item) => 'item_ids[]=' + item).join("&")
  return api.get(`/sip_order/list-otorisator?${params}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {
  getSIPAll,
  createSIP,
  getSIPDetail,
  rejectSIP,
  revisionSIP,
  approveSIP,
  getPOApproved,
  getPOforSIP,
  getSIPApproval,
  getAccesses,
  getSIPSearch,
  getSIPApprovalSearch,
  getPOApprovedSearch,
  unduhSIP,
  rollbackSIP,
  updateAmendment,
  resubmitSIP,
  getCommentSIP,
  signingDocument,
  generateOTP,
  getRegardingSIP,
  getOtorisator
}
